


















































    import PhotoSwipe from 'photoswipe/dist/photoswipe';
    import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { EventBus } from '../helpers/bus';
    import { isAttachedToDom, uid } from '../helpers/utils';
    import BaseComponent from './Base';

    const DEFAULT_EVENTS: string[] = [
    'beforeChange',
    'afterChange',
    'imageLoadComplete',
    'resize',
    'gettingData',
    'mouseUsed',
    'initialZoomIn',
    'initialZoomInEnd',
    'initialZoomOut',
    'initialZoomOutEnd',
    'parseVerticalMargin',
    'close',
    'unbindEvents',
    'destroy',
    'updateScrollOffset',
    'preventDragEvent',
    'shareLinkClick',
];

    export interface PSWPGalleryItem {
    container: HTMLElement;
    template?: string;
    component?: DynamicContentComponent;
    html?: string;
    src?: string;
    title?: string;
    w?: number;
    h?: number;
}

    export interface PSWPGallery {
    currItem: PSWPGalleryItem;
    items: PSWPGalleryItem[];
    options: { [key: string]: any };
    init();
    listen(evt: string, cb: any);
    goTo(index: number);
    destroy();
    getCurrentIndex(): number;
    invalidateCurrItems(): void;
    updateSize(state: boolean): void;
    setContent(holder: Element, index: number): void;
}

    export interface DynamicContentComponent extends Vue {
    attach(): void;
}

    @Component
export default class PhotoSwipeWrapper extends BaseComponent {
    @Prop(String) protected readonly photoSwipeId: string;
    @Prop(Array) protected readonly items: any[];
    @Prop({ type: Object, default: () => ({ tapToClose: true }) }) protected readonly options: any;

    protected gallery: PSWPGallery | null = null;

    protected getThumbBounds(s: HTMLElement): {x: number, y: number, w: number } {
        if (s.getBoundingClientRect) {
            const rect = s.getBoundingClientRect();
            const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
        return { x: 0, y: 0, w: 0 };
    }

    protected get defaultOptions(): any {
        return {...{
            index: 0,
            showHideOpacity: true,
            history: false,
            loop: false,
            tapToClose: true,
            galleryUID: this.uniqId,
            tapToToggleControls: false,
            bgOpacity: .65,
        }, ...this.options};
    }

    protected createDynamicContent(html?: string): DynamicContentComponent {
        return new Vue({
            components: this.$root.$options.components,
            template: `<div>${html || ''}</div>`,
            store: this.$root.$options.store,
            propsData: {
                key: uid(),
            },
            methods: {
                attach(): void {
                    this.$emit('attached');
                },
            },
            mounted(): void {
                this.$emit('mounted');
            },
            beforeDestroy(): void {
                this.$emit('beforeDestroy');
            },
        });
    }

    protected appendDynamicContent(item: PSWPGalleryItem): void {
        if (!item.component) {
            item.component = this.createDynamicContent(item.html).$mount();
        }
        if (!item.component.$el || !isAttachedToDom(item.component.$el)) {
            item.container.innerHTML = '';
            item.container.appendChild(item.component.$el);
            item.component.attach();
        }
    }

    protected getItemByIndex(index: number): PSWPGalleryItem | undefined {
        if (this.gallery === null) {
            return undefined;
        }
        return this.gallery.items[index] || undefined;
    }

    protected onBeforeSetContent(holder: Element, index: number): void {
        const item = this.getItemByIndex(index);
        if (!item || !item.component) {
            return;
        }
        // maybe do something
    }

    protected onAfterSetContent(holder: Element, index: number): void {
        const item = this.getItemByIndex(index);
        if (!item || !item.html) {
            return;
        }
        this.appendDynamicContent(item);
    }

    protected bindEvents(): void {
        DEFAULT_EVENTS.forEach((eventName) => {
            if (this.gallery && this.gallery.listen) {
                this.gallery.listen(eventName, (...args) => {
                    this.$emit(eventName, ...args);
                    EventBus.$emit(`pswp:${eventName}`, ...args);
                });
            }
        });
    }

    protected mounted(): void {
        const vm = this;
        const emitter = this.photoSwipeId ? this.$root : this.$parent;

        emitter.$on(this.photoSwipeId ? `slideClick:${this.photoSwipeId}` : `slideClick`, (items: any[], index: number, slide: HTMLElement) => {
            this.gallery = new PhotoSwipe(
                this.$refs.pswp,
                PhotoSwipeUI_Default,
                items,
                {
                    ...this.defaultOptions,
                    ...{
                        index,
                        getThumbBoundsFn: () => this.getThumbBounds(slide),
                    },
                },
            );

            if (this.gallery) {
                // Override some methods to add compatibility with Vue components
                const baseFunc = this.gallery.setContent;
                this.gallery.setContent = function(holder: Element, idx: number): any {
                    vm.$emit('beforeSetContent', holder, idx);
                    const result = baseFunc(holder, idx);
                    vm.$emit('afterSetContent', holder, idx);
                    return result;
                };

                this.$on('beforeSetContent', this.onBeforeSetContent);
                this.$on('afterSetContent', this.onAfterSetContent);
                this.gallery.init();
                this.bindEvents();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PhotoSwipeWrapper.vue